import axios from "axios";
import Swal from "sweetalert2";

function getCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) {
    let val = parts.pop().split(";").shift();
    if (val) {
      try {
        val = decodeURIComponent(val);
      } catch (_) {}
    }
    return val || null;
  }
  return null;
}

axios.interceptors.request.use((config) => {
  const token = getCookie("accessToken");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export default function (app) {
  const router = app.config.globalProperties?.$router;
  if (!router) return;

  axios.interceptors.response.use(
    response => response,
    error => {
      const status = error.response?.status;
      const message = error.response?.data?.message ?? '';
      const isUnauthenticated = status === 401
        || (typeof message === 'string' && message.toLowerCase().includes('não autenticado'))
        || (typeof message === 'string' && message.toLowerCase().includes('unauthenticated'));

      if (isUnauthenticated) {
        const isLoginRequest = error.config?.url?.includes?.('/api/auth/login');
        if (!isLoginRequest) {
          router.push({ name: 'login' });
        }
        return Promise.reject(error);
      }

      // Trata erros de Acesso Negado (403) globalmente
      const isForbidden = status === 403 || (typeof message === 'string' && message.toLowerCase().includes('acesso negado'));
      if (isForbidden) {
        // Aplica o filtro de blur no conteúdo principal
        const appWrapper = document.querySelector('.layout-wrapper');
        if (appWrapper) {
          appWrapper.style.filter = 'blur(6px)';
          appWrapper.style.pointerEvents = 'none';
        }

        Swal.fire({
          icon: 'error',
          title: 'Acesso Negado',
          text: 'Você não tem permissão para realizar esta ação ou acessar esta funcionalidade. Retornando ao início.',
          allowOutsideClick: false,
          allowEscapeKey: false,
          confirmButtonText: 'OK',
          backdrop: 'rgba(0,0,0,0.5)'
        }).then(() => {
          if (appWrapper) {
            appWrapper.style.filter = 'none';
            appWrapper.style.pointerEvents = 'auto';
          }
          window.location.href = '/';
        });

        // Retorna uma Promise que nunca resolve para interromper 
        // a execução da requisição no componente e evitar pop-ups locais de erro.
        return new Promise(() => {});
      }

      return Promise.reject(error);
    },
  );
}
